/**
 * Variantify badge fix
 * --------------------
 * Variantify clones the first collection card client-side for each variant.
 * Each clone is an <li data-variantify="clone" data-variant-id="..."> but the
 * badge inside is copied verbatim from the original card, so every clone shows
 * the first variant's badge instead of its own.
 *
 * This script reads the per-variant badge map emitted by
 * snippets/variantify-badge-fix.liquid and rewrites each clone's badge by its
 * data-variant-id. A MutationObserver handles clones that Variantify inserts
 * after this script runs.
 */
(function () {
  'use strict';

  var DATA_EL_ID = 'variantify-badge-data';
  var badgeMap = null;

  function loadBadgeMap() {
    if (badgeMap) return badgeMap;
    var el = document.getElementById(DATA_EL_ID);
    if (!el) return null;
    try {
      badgeMap = JSON.parse(el.textContent);
    } catch (e) {
      badgeMap = null;
    }
    return badgeMap;
  }

  // Mirrors the markup produced by snippets/badges.liquid for a single badge.
  function buildBadgeSpan(badge) {
    var span = document.createElement('span');
    span.className = 'bg-[var(--bg-color)] text-[var(--text-color)] uppercase font-medium';
    span.style.setProperty('--bg-color', badge.background_color || '');
    span.style.setProperty('--text-color', badge.text_color || '');
    span.textContent = badge.title || '';
    return span;
  }

  function fixClone(li) {
    if (li.hasAttribute('data-variantify-badge-fixed')) return;

    var map = loadBadgeMap();
    if (!map) return;

    var variantId = li.getAttribute('data-variant-id');
    if (!variantId || !(variantId in map)) {
      // No data for this variant — reveal whatever is there rather than hiding forever.
      li.setAttribute('data-variantify-badge-fixed', '');
      return;
    }

    var badges = map[variantId] || [];
    var container = li.querySelector('.card__badge .flex');

    if (!container) {
      // Clone has no metaobject-badge container (e.g. only a Rea/sold-out badge).
      li.setAttribute('data-variantify-badge-fixed', '');
      return;
    }

    // Remove the copied metaobject badge spans, keep any non-metaobject badges
    // (sold out / sale) that live outside this .flex container untouched.
    container.querySelectorAll('span').forEach(function (s) {
      s.remove();
    });

    badges.forEach(function (badge) {
      container.appendChild(buildBadgeSpan(badge));
    });

    li.setAttribute('data-variantify-badge-fixed', '');
  }

  function fixAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var clones = scope.querySelectorAll('li[data-variantify="clone"]:not([data-variantify-badge-fixed])');
    clones.forEach(fixClone);
  }

  function init() {
    if (!loadBadgeMap()) return;

    fixAll(document);

    // Observe the whole document rather than a single grid: pages built from
    // featured-collection sections (e.g. /collections/tvattmedel) have no
    // #product-grid, and the first ".product-grid" on the page may belong to
    // the header's search panel, so scoping to one grid misses the clones.
    var target = document.body;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('li[data-variantify="clone"]')) {
            fixClone(node);
          } else if (node.querySelectorAll) {
            fixAll(node);
          }
        }
      }
    });

    observer.observe(target, { childList: true, subtree: true });

    // Safety net: never leave a badge hidden forever if a clone is somehow
    // missed (e.g. Variantify markup changes). Reveal whatever is there.
    setTimeout(function () {
      document
        .querySelectorAll('li[data-variantify="clone"]:not([data-variantify-badge-fixed])')
        .forEach(function (li) {
          fixClone(li);
          li.setAttribute('data-variantify-badge-fixed', '');
        });
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
